import {faCheckCircle} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';


const propTypes = {
  value: PropTypes.bool,
};
/**
 * Renders a boolean value as a checked checkbox.
 */
export default function BooleanCell({value}) {
  if (!value) {
    return '';
  }
  return (
    <div className="text-center">
      <FontAwesomeIcon icon={faCheckCircle} />
    </div>
  );
}
BooleanCell.propTypes = propTypes;
